import type { ZodSchema } from 'zod';
import * as z from 'zod';

export const paginatedResponseSchema = <T>(data: ZodSchema<T>) =>
  z.object({
    data: z.array(data),
    links: z.object({
      first: z.string(),
      last: z.string(),
      prev: z.string().nullable(),
      next: z.string().nullable(),
    }),
    meta: z.object({
      current_page: z.number().prefault(1),
      from: z.number(),
      last_page: z.number(),
      links: z.array(z.object({ url: z.string(), label: z.string(), active: z.boolean() })),
      path: z.string(),
      per_page: z.number(),
      to: z.number(),
      total: z.number(),
    }),
  });

export const paginatedOptionalResponseSchema = <T>(data: ZodSchema<T>) =>
  z.object({
    data: z.array(data).optional(),
    links: z
      .object({
        first: z.string(),
        last: z.string(),
        prev: z.string().nullable(),
        next: z.string().nullable(),
      })
      .optional(),
    meta: z
      .object({
        current_page: z.number(),
        from: z.number(),
        last_page: z.number(),
        links: z.array(z.object({ url: z.string(), label: z.string(), active: z.boolean() })),
        path: z.string(),
        per_page: z.number(),
        to: z.number(),
        total: z.number(),
      })
      .optional(),
  });

export type PaginatedResponseSchema<T> = z.infer<ReturnType<typeof paginatedOptionalResponseSchema<T>>>;
